// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"1306191d","513":"e621c7ad","703":"13cfe0e5","787":"65a8506c"}[chunkId] + ".chunk.js";
};